/* eslint-disable @altermaind/you-shall-not-pass */
// Auto-generated from OpenAPI enums. Do not edit manually.

export enum SkillsType {
  SOFT_SKILL = 'SOFT_SKILL',
  HARD_SKILL = 'HARD_SKILL',
}

export enum StatusAssessment {
  SENT = 'SENT',
  FINISHED = 'FINISHED',
}
